/**
 * Test IDs for QA automation.
 */
export const testIds = {
  tractorsListNewTractor: "tractors-list-new-tractor",
} as const;
